module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isAddModalShown) ? _c('div', [_c('div', {
    staticClass: "modal-mask",
    attrs: {
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "overlay-mask"
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content modal-edit-bg"
  }, [_c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "close_btn",
    on: {
      "click": function($event) {
        return _vm.CloseModal()
      }
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 edit_account_modal"
  }, [_c('div', {
    staticClass: "my-account-title"
  }, [_vm._v("Add Eye Doctor Information")]), _vm._v(" "), _c('div', {
    staticClass: "account_section_box"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-lg-8 col-md-8 col-sm-8 col-xs-8"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("NPI Number\n                                    "), (!_vm.NewDoctor.useLicenseNumber) ? _c('span', [_vm._v("*")]) : _vm._e(), _vm._v(" "), _c('span', {
    attrs: {
      "data-balloon": _vm.npiTooltip,
      "data-balloon-pos": "down",
      "data-balloon-length": "large"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle-o"
  })])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.NewDoctor.npiNumber),
      expression: "NewDoctor.npiNumber"
    }],
    staticClass: "form-control input_field",
    class: {
      error_field: _vm.NewDoctorValidationResult.EyeDoctorNpiNumber
    },
    attrs: {
      "type": "text",
      "maxlength": "10"
    },
    domProps: {
      "value": (_vm.NewDoctor.npiNumber)
    },
    on: {
      "paste": function($event) {
        return _vm.pasteNpiNumber($event)
      },
      "keypress": function($event) {
        return _vm.G_NumberCheck(this.event);
      },
      "keyup": function($event) {
        return _vm.ValidateNpiNumberEyeDoctor()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.NewDoctor, "npiNumber", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.NewDoctorValidationResult.EyeDoctorNpiNumber) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.NewDoctorValidationResult.EyeDoctorNpiNumber))]) : _vm._e(), _vm._v(" "), (_vm.invalidNpiNumberPaste) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v("Sorry, only numeric NPI values can be pasted here.")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "form-check"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.NewDoctor.useLicenseNumber),
      expression: "NewDoctor.useLicenseNumber"
    }],
    staticClass: "form-check-input",
    attrs: {
      "value": "",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.NewDoctor.useLicenseNumber) ? _vm._i(_vm.NewDoctor.useLicenseNumber, "") > -1 : (_vm.NewDoctor.useLicenseNumber)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.NewDoctor.useLicenseNumber,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.NewDoctor, "useLicenseNumber", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.NewDoctor, "useLicenseNumber", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.NewDoctor, "useLicenseNumber", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v("Use License Number")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Relationship*\n                                          "), _c('span', {
    attrs: {
      "data-balloon": _vm.relationshipTooltip,
      "data-balloon-pos": "down",
      "data-balloon-length": "large"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle-o"
  })])]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.NewDoctor.Role),
      expression: "NewDoctor.Role"
    }],
    staticClass: "form-control",
    class: {
      error_field: _vm.NewDoctorValidationResult.EyeDoctorRole
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.NewDoctor, "Role", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', [_vm._v("Self")]), _vm._v(" "), _c('option', [_vm._v("Employee")]), _vm._v(" "), _c('option', [_vm._v("Contractor")]), _vm._v(" "), _c('option', [_vm._v("Unaffiliated")]), _vm._v(" "), _c('option', [_vm._v("Other")])]), _vm._v(" "), (_vm.NewDoctorValidationResult.EyeDoctorRole) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.NewDoctorValidationResult.EyeDoctorRole))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-8 col-md-8 col-sm-8 col-xs-8"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-6 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Doctor's First Name*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.NewDoctor.firstName),
      expression: "NewDoctor.firstName"
    }],
    staticClass: "form-control input_field capitalize",
    class: {
      error_field: _vm.NewDoctorValidationResult.EyeDoctorFirstName
    },
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.NewDoctor.firstName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.NewDoctor, "firstName", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.NewDoctorValidationResult.EyeDoctorFirstName) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.NewDoctorValidationResult.EyeDoctorFirstName))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Doctor's Last Name*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.NewDoctor.lastName),
      expression: "NewDoctor.lastName"
    }],
    staticClass: "form-control input_field capitalize",
    class: {
      error_field: _vm.NewDoctorValidationResult.EyeDoctorLastName
    },
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.NewDoctor.lastName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.NewDoctor, "lastName", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.NewDoctorValidationResult.EyeDoctorLastName) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.NewDoctorValidationResult.EyeDoctorLastName))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Suffix*")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.NewDoctor.suffix),
      expression: "NewDoctor.suffix"
    }],
    staticClass: "form-control select_field",
    class: {
      error_field: _vm.NewDoctorValidationResult.EyeDoctorSuffix
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.NewDoctor, "suffix", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.Suffix), function(value, key) {
    return _c('option', {
      domProps: {
        "value": key
      }
    }, [_vm._v(_vm._s(key))])
  }), 0), _vm._v(" "), (_vm.NewDoctorValidationResult.EyeDoctorSuffix) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.NewDoctorValidationResult.EyeDoctorSuffix))]) : _vm._e()])])])])]), _vm._v(" "), (_vm.NewDoctor.useLicenseNumber) ? _c('div', {
    staticClass: "row"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "col-lg-8 col-md-8 col-sm-8 col-xs-8"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-6 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("License Number *")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.NewDoctor.licenseNumber),
      expression: "NewDoctor.licenseNumber"
    }],
    staticClass: "form-control input_field",
    class: {
      error_field: _vm.NewDoctorValidationResult.EyeDoctorLicenseNumber
    },
    attrs: {
      "type": "text",
      "maxlength": "18"
    },
    domProps: {
      "value": (_vm.NewDoctor.licenseNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.NewDoctor, "licenseNumber", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.NewDoctorValidationResult.EyeDoctorLicenseNumber) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.NewDoctorValidationResult.EyeDoctorLicenseNumber))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("State *")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.NewDoctor.state),
      expression: "NewDoctor.state"
    }],
    staticClass: "form-control select_field",
    class: {
      error_field: _vm.NewDoctorValidationResult.EyeDoctorState
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.NewDoctor, "state", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.State), function(value, key) {
    return _c('option', {
      domProps: {
        "value": value
      }
    }, [_vm._v(_vm._s(value))])
  }), 0), _vm._v(" "), (_vm.NewDoctorValidationResult.EyeDoctorState) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.NewDoctorValidationResult.EyeDoctorState))]) : _vm._e()])])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "col-lg-8 col-md-8 col-sm-8 col-xs-8"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Year Licensed")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-4 col-md-6 col-sm-12 col-xs-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.NewDoctor.yearsInPractice),
      expression: "NewDoctor.yearsInPractice"
    }],
    staticClass: "form-control input_field",
    attrs: {
      "type": "number",
      "min": "1"
    },
    domProps: {
      "value": (_vm.NewDoctor.yearsInPractice)
    },
    on: {
      "keypress": function($event) {
        return _vm.G_NumberCheck(this.event)
      },
      "keyup": function($event) {
        return _vm.G_NumberOfYearsCheck(_vm.NewDoctor, 'yearsInPractice')
      },
      "blur": function($event) {
        return _vm.CheckYearLicense(_vm.NewDoctor.yearsInPractice)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.NewDoctor, "yearsInPractice", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.NewDoctorValidationResult.EyeDoctorYearsInPractice) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.NewDoctorValidationResult.EyeDoctorYearsInPractice))]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "col-lg-8 col-md-8 col-sm-8 col-xs-8"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Doctor's Email Address*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.NewDoctor.emailAddress),
      expression: "NewDoctor.emailAddress"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('email'),
      expression: "'email'"
    }],
    staticClass: "form-control input_field",
    class: {
      error_field: _vm.NewDoctorValidationResult.EyeDoctorEmailAddress
    },
    attrs: {
      "name": "email",
      "type": "email",
      "data-vv-as": "email",
      "oninput": "this.value = this.value.toLowerCase()"
    },
    domProps: {
      "value": (_vm.NewDoctor.emailAddress)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.NewDoctor, "emailAddress", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('email') && !_vm.NewDoctorValidationResult.EyeDoctorEmailAddress),
      expression: "errors.has('email') && !NewDoctorValidationResult.EyeDoctorEmailAddress"
    }],
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.first('email')))]), _vm._v(" "), (_vm.NewDoctorValidationResult.EyeDoctorEmailAddress) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.NewDoctorValidationResult.EyeDoctorEmailAddress))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "col-lg-8 col-md-8 col-sm-8 col-xs-8"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm._l((_vm.CheckboxIndividual), function(value, key) {
    return _c('div', {
      staticClass: "form-check"
    }, [_c('p', {
      staticClass: "form-check-label"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.NewDoctor.organizations.list),
        expression: "NewDoctor.organizations.list"
      }],
      staticClass: "form-check-input",
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": key,
        "checked": Array.isArray(_vm.NewDoctor.organizations.list) ? _vm._i(_vm.NewDoctor.organizations.list, key) > -1 : (_vm.NewDoctor.organizations.list)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.NewDoctor.organizations.list,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = key,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(_vm.NewDoctor.organizations, "list", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(_vm.NewDoctor.organizations, "list", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(_vm.NewDoctor.organizations, "list", $$c)
          }
        }
      }
    }), _vm._v("\n                                          " + _vm._s(key) + "\n                                       ")])])
  }), _vm._v(" "), (_vm.NewDoctor.organizations.list.indexOf('Other') >= 0) ? _c('div', {
    staticClass: "form-group"
  }, [_c('p', [_vm._v("Please enter any other professional organizations you are associated with separated by semicolon(;).")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.NewDoctor.organizations.others),
      expression: "NewDoctor.organizations.others"
    }],
    staticClass: "form-control input_field",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.NewDoctor.organizations.others)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.NewDoctor.organizations, "others", $event.target.value)
      }
    }
  })]) : _vm._e()], 2)])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 center"
  }, [_c('button', {
    staticClass: "btn g-color-white g-bg-main g-bg-primary--hover g-rounded-10 g-mx-10 g-my-10 g-font-size-17 g-px-40",
    on: {
      "click": function($event) {
        return _vm.AddThisDoctor()
      }
    }
  }, [_vm._v("Add This Doctor")]), _vm._v(" "), _c('button', {
    staticClass: "btn g-color-white g-bg-main g-bg-primary--hover g-rounded-10 g-mx-10 g-my-10 g-font-size-17 g-px-40",
    on: {
      "click": function($event) {
        return _vm.CloseModal()
      }
    }
  }, [_vm._v("Cancel")])])])])])])])])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-4 col-md-4 col-sm-4 col-xs-4"
  }, [_c('label', {
    staticClass: "account_label"
  }, [_vm._v("NPI Number:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-4 col-md-4 col-sm-4 col-xs-4"
  }, [_c('label', {
    staticClass: "account_label"
  }, [_vm._v("Name: ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-4 col-md-4 col-sm-4 col-xs-4"
  }, [_c('label', {
    staticClass: "account_label"
  }, [_vm._v("License Number/State:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-4 col-md-4 col-sm-4 col-xs-4"
  }, [_c('label', {
    staticClass: "account_label"
  }, [_vm._v("Year Licensed:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-4 col-md-4 col-sm-4 col-xs-4"
  }, [_c('label', {
    staticClass: "account_label"
  }, [_vm._v("Doctor's Email Address:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-4 col-md-4 col-sm-4 col-xs-4"
  }, [_c('label', {
    staticClass: "account_label"
  }, [_vm._v("Professional Associations:")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-5d3a306d", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5d3a306d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/portal/userAccount/accountList/AddDoctor.vue
// module id = 512
// module chunks = 3